<span class="center-content flex-fill d-flex flex-wrap"><ng-content></ng-content></span>
<ng-content select="[slot=end]"></ng-content>